import { motion } from "framer-motion";
import { SectionContainer } from "@/components/shared/SectionContainer";

const STATS = [
  { label: "Years coding", value: "6+" },
  { label: "Cloud-native projects", value: "8" },
  { label: "Currently studying", value: "MSc Data Science" },
];

export function AboutSection() {
  return (
    <SectionContainer className="border-t border-border/50">
      <div className="grid gap-12 lg:grid-cols-[1.1fr,1fr]">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-serif text-3xl sm:text-4xl">
            About <span className="text-primary">Salahaldin</span>
          </h2>
          <p className="mt-5 text-muted-foreground">
            Palestinian Software Developer and MSc Data Science student at the{" "}
            <span className="text-foreground">University of Naples Federico II</span> (DIETI).
            Former Software Developer at the <span className="text-foreground">Palestinian Ministry of Finance</span>,
            where I built payroll systems in .NET Core &amp; Oracle and shipped Angular front-ends
            for thousands of civil servants.
          </p>
          <p className="mt-4 text-muted-foreground">
            Freelancer since 2022 — I build full-stack tools for NGOs, olive-oil exporters,
            and curious minds who&apos;d rather ask their database a question in plain English.
            I care about <span className="text-foreground">shipped software</span>,{" "}
            <span className="text-foreground">clean architecture</span>, and the strange corner
            where distributed systems meet applied machine learning.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="grid gap-4"
        >
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-border bg-card/60 p-5 backdrop-blur"
            >
              <div className="font-serif text-3xl text-primary">{s.value}</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </SectionContainer>
  );
}
